import { render, staticRenderFns } from "./VariantSifterV2gTable.vue?vue&type=template&id=cb1b888a&scoped=true&"
import script from "./VariantSifterV2gTable.vue?vue&type=script&lang=js&"
export * from "./VariantSifterV2gTable.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterV2gTable.vue?vue&type=style&index=0&id=cb1b888a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1b888a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb1b888a')) {
      api.createRecord('cb1b888a', component.options)
    } else {
      api.reload('cb1b888a', component.options)
    }
    module.hot.accept("./VariantSifterV2gTable.vue?vue&type=template&id=cb1b888a&scoped=true&", function () {
      api.rerender('cb1b888a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterV2gTable.vue"
export default component.exports